<template>
  <div class="landing">
    <img :src="getSrc" alt="logistics picture"/>
    <div class="circles">
      <call-to-action :text="$t('landing.site.text')" :title="$t('landing.site.title')" icon="pin"/>
      <call-to-action
        :text="$t('landing.sector.text')"
        :title="$t('landing.sector.title')"
        icon="industrial"
        v-if="mode === ModeEnum.RELIABILITY"/>
      <call-to-action
        :text="$t('landing.customer.text')"
        :title="$t('landing.customer.title')"
        icon="shop"
        v-if="mode === ModeEnum.QUALITY|| ModeEnum.MESH_QUALITY"/>
      <call-to-action :text="$t('landing.period.text')" :title="$t('landing.period.title')" icon="calendar"/>
    </div>
  </div>
</template>

<script>
  import CallToAction from '@/components/landing/CallToAction'
  import { mapGetters } from 'vuex'
  import {ModeEnum} from "@/utils/consts";

  export default {
    name: 'Home',
    components: { CallToAction },
    computed: {
      ModeEnum() {
        return ModeEnum
      },
      ...mapGetters('context', ['mode']),

      getSrc() {
        return require('@/assets/icons/logistics.svg')
      }
    }
  }
</script>

<style lang="scss" scoped>
  .landing {
    padding: 4rem 4rem 0 4rem;
    height: calc(82% - 40px);
    overflow-y: scroll;
    @include display-flex(center, space-between, column);

    img {
      height: 35%;
    }

    .circles {
      flex: 1;
      @include display-flex(center, space-around, row);

      .callToAction {
        width: 30%;
      }
    }
  }
</style>
